/**
 * Normalizes phone input to E.164 for Auth0 SMS passwordless (must match backend E164PhoneNumberNormalizer).
 */
export function normalizePhoneForAuth0Sms(input: string | null | undefined): string | null {
  if (input == null || String(input).trim() === '') {
    return null;
  }
  let digits = String(input).replace(/\D/g, '');
  while (digits.length > 4 && digits.startsWith('00')) {
    digits = digits.slice(2);
  }
  if (digits.length === 0) {
    return null;
  }
  if (digits.length > 15) {
    return null;
  }
  if (digits.length === 10) {
    if (digits[0] === '0' || digits[0] === '1') {
      return null;
    }
    return '+1' + digits;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return '+' + digits;
  }
  if (digits.length >= 10 && digits.length <= 15) {
    return '+' + digits;
  }
  return null;
}
